import React, {Component, Fragment} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {Assignment, Create, Search} from '@material-ui/icons';
import i18n from '../i18n/i18n';
import {menuItem, menuItemIcon, menuItemText, menuItemTitle} from '../styles';

const styles = () => ({});

class DrawerSectionItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            anchor: null
        };
    }

    handleClick = e => {
        this.setState({open: !this.state.open, anchor: e.currentTarget});
    };

    handleSectionCreateClick = () => {
        this.setState({open: false});
        this.props.onCreateSectionClick();
    };

    handleShowAllClick = () => {
        this.setState({open: false});
        this.props.onShowAllClick();
    };

    render() {
        return (
            <Fragment>
                <ListItem button onClick={this.handleClick} style={menuItem}>
                    <div style={menuItemTitle}>
                        <div style={menuItemIcon}>
                            <ListItemIcon ><Assignment/></ListItemIcon>
                        </div>
                        <div style={menuItemText}>
                            <ListItemText primary={i18n.t('SECTION_DRAWER_ITEM')}/>
                        </div>
                    </div>
                    <div style={{
                        display: this.state.open ? 'block' : 'none',
                    }}>
                        <List>
                            <ListItem button onClick={this.handleSectionCreateClick}>
                                <ListItemIcon><Create/></ListItemIcon>
                                <ListItemText primary={i18n.t('SECTION_CREATION_TITLE')}/>
                            </ListItem>
                            <ListItem button onClick={this.handleShowAllClick}>
                                <ListItemIcon><Search/></ListItemIcon>
                                <ListItemText primary={i18n.t('SHOW_ALL_SECTIONS_TITLE')}/>
                            </ListItem>
                        </List>
                    </div>
                </ListItem>
            </Fragment>
        );
    }
}

export default withStyles(styles)(DrawerSectionItem);
